@if (!readonly) {
    <mat-form-field class="flex" style="width: 100%;"
                    [ngClass]="{'cb-soft-required': softRequired && !required }"
    >
        <mat-label>{{ label }}</mat-label>
        @if (value) {
            <span matPrefix
                  style="margin-right: 12px"
                  [ngClass]="{'is-credit': getIsCreditClass()}">
        $
      </span>
        }
        <input matInput
               #inputRef
               cbTwoDp
               [decimals]="decimals"
               [name]="internalName"
               type="text"
               [(ngModel)]="value"
               [ignoreDirty]="ignoreDirty"
               [required]="required"
               [maxlength]="maxlength + valueFormatCharCount"
               [pattern]="pattern"
               autocomplete="off"
               [disabled]="disabled"
               [ngClass]="{'is-credit': getIsCreditClass() }" />
    </mat-form-field>
}
@if (readonly && value && (displayCreditBrackets() || displayCredit() || displayNonCredit())) {
    <div>
        @if (displayCreditBrackets()) {
            <cb-display-value-new
                [label]="label"
                class="is-credit">
                ({{ -cleanCurrencyValue(value) | cbCurrency }})
            </cb-display-value-new>
        }
        @if (displayCredit()) {
            <cb-display-value-new
                [label]="label"
                class="is-credit">
                {{ cleanCurrencyValue(value) | cbCurrency }}
            </cb-display-value-new>
        }
        @if (displayNonCredit()) {
            <cb-display-value-new
                [label]="label">
                {{ cleanCurrencyValue(value) | cbCurrency }}
            </cb-display-value-new>
        }
    </div>
}
